import useClassNames from '@medflex/hooks/useClassNames';
import React, { forwardRef } from 'react';
import { IconNavigationMore } from '../Icons';

const ContextMenuTriggerButton = forwardRef(({ className, hidden, ...props }, ref) => {
  const cn = useClassNames(
    () => [
      hidden ? 'hidden' : 'flex',
      'focus:outline-none',
      'hover:bg-slate-300',
      'rounded-lg',
      'text-slate-600',
      'p-2',
      'justify-center',
      'items-center',
      'flex-shrink-0',
      className,
    ],
    [className],
  );

  return (
    <div role="button" className={cn} tabIndex="-1" ref={ref} {...props}>
      <IconNavigationMore />
    </div>
  );
});

export default ContextMenuTriggerButton;
